import React, { useState } from 'react'
import { Config, Mobru, Quay } from 'src/types'
import ExpandedTable from 'src/components/base/ExpandedTable'
import produce from 'immer'
import Button from 'src/components/base/Button'
import { confirmDeletePopup } from 'src/components/popup/confirmDeletePopup'

import { INITIAL_MOBRU } from './constants'
import MobruModal from './modals/MobruModal'

export type TPropsQuayConfigMobruSection = {
  config: Quay
  setConfig: React.Dispatch<React.SetStateAction<Config>>
}

function QuayConfigMobruSection({ config, setConfig }: TPropsQuayConfigMobruSection) {
  const [selectedMobru, setSelectedMobru] = useState<(Mobru & { index: number }) | null>(null)
  const onAddMobru = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    setSelectedMobru({ ...INITIAL_MOBRU, index: config.mobrus.length })
  }
  const onRemoveMobru = (index: number, mobru: Mobru) => {
    confirmDeletePopup({
      itemName: mobru.name,
      onConfirm: () => {
        setConfig(
          produce((draft: Config) => {
            draft.quays.find(quay => quay.name === config.name)?.mobrus.splice(index, 1)
          })
        )
      },
      alert: true
    })
  }

  return (
    <>
      <ExpandedTable emptyMessage="No mobrus defined" empty={config?.mobrus.length === 0}>
        <ExpandedTable.Header>
          <ExpandedTable.Title>Cargo belts</ExpandedTable.Title>
          <ExpandedTable.Actions>
            <Button variant="brand-tertiary" icon="fa fa-plus" onClick={onAddMobru}>
              Add Cargo belts
            </Button>
          </ExpandedTable.Actions>
        </ExpandedTable.Header>
        <ExpandedTable.Body>
          <ExpandedTable.Row>
            <ExpandedTable.Cell asHeader style={{ width: '30%' }}>
              Cargo belts name
            </ExpandedTable.Cell>
            <ExpandedTable.Cell asHeader style={{ width: '20%' }}>
              Bollard start
            </ExpandedTable.Cell>
            <ExpandedTable.Cell asHeader style={{ width: '20%' }}>
              Bollard end
            </ExpandedTable.Cell>
            <ExpandedTable.Cell asHeader style={{ width: '20%' }}>
              Products
            </ExpandedTable.Cell>
            <ExpandedTable.Cell asHeader style={{ width: '10%' }} />
          </ExpandedTable.Row>
          {config?.mobrus.map((mobru, index) => {
            return (
              <ExpandedTable.Row key={index}>
                <ExpandedTable.Cell style={{ width: '30%' }}>{mobru.name}</ExpandedTable.Cell>
                <ExpandedTable.Cell style={{ width: '20%' }}>{mobru.bollardStart}</ExpandedTable.Cell>
                <ExpandedTable.Cell style={{ width: '20%' }}>{mobru.bollardEnd}</ExpandedTable.Cell>
                <ExpandedTable.Cell style={{ width: '20%' }}>
                  {mobru.products.map(p => p.product).join(', ')}
                </ExpandedTable.Cell>
                <ExpandedTable.Cell className="align-right" style={{ width: '10%' }}>
                  <ExpandedTable.CellActions>
                    <Button
                      onClick={() => setSelectedMobru({ ...mobru, index })}
                      size="small"
                      variant="neutral-tertiary"
                      icon="fa fa-edit"
                    />
                    <Button
                      onClick={() => onRemoveMobru(index, mobru)}
                      size="small"
                      variant="neutral-tertiary"
                      icon="fa fa-trash"
                    />
                  </ExpandedTable.CellActions>
                </ExpandedTable.Cell>
              </ExpandedTable.Row>
            )
          })}
        </ExpandedTable.Body>
      </ExpandedTable>
      {selectedMobru && (
        <MobruModal
          selectedMobru={selectedMobru}
          isOpen={!!selectedMobru}
          onMobruConfirm={mobru => {
            if (mobru) {
              setConfig(
                produce((draft: Config) => {
                  const quay = draft.quays.find(quay => quay.name === config.name)
                  const mobruIndex = selectedMobru.index
                  if (mobruIndex === -1) {
                    quay.mobrus.push(mobru)
                  } else {
                    quay.mobrus[mobruIndex] = mobru
                  }
                })
              )
            }
            setSelectedMobru(null)
          }}
          onCancel={() => setSelectedMobru(null)}
        />
      )}
    </>
  )
}

export default QuayConfigMobruSection
